// React / Next
import { Outlet, createRootRoute, ScrollRestoration } from '@tanstack/react-router';

// Components
import { MainLayout } from '../layouts/MainLayout/MainLayout';
import { SmoothScroll } from '../components/SmoothScroll/SmoothScroll';
import { SEO } from '../components/SEO/SEO';
import { NotFoundPage } from '../pages/NotFoundPage/NotFoundPage';

// Hooks
import { usePostHogPageview } from '../hooks/usePostHogPageview';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
});

function RootComponent() {
  usePostHogPageview();

  return (
    <SmoothScroll>
      <SEO />
      <ScrollRestoration />
      <MainLayout>
        <Outlet />
      </MainLayout>
    </SmoothScroll>
  );
}
